export type BadgeProps = {
  children: string;
  tone?: "mint" | "amber" | "neutral";
};

const tones = {
  mint: "bg-mint/45 text-mint-dark",
  amber: "bg-amber/25 text-[#7a5700]",
  neutral: "bg-brand-100 text-brand-900",
};

export function Badge({ children, tone = "neutral" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${tones[tone]}`}
    >
      {children}
    </span>
  );
}
